import * as Yup from "yup"

export const engagementFormSchema = Yup.object().shape({
  first_name: Yup.string().required("First name is required"),
  last_name: Yup.string().required("Last name is required"),
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  phone: Yup.string().required("Phone is required"),
  loid: Yup.string().required("Loan officer is required"),
  credit_score: Yup.number()
    .required("Credit score is required")
    .min(0, "Credit score must be between 0 and 850")
    .max(850, "Credit score must be between 0 and 850"),
  loan_amount: Yup.string().required("Loan amount is required")
})
